import * as skylineApi from "../skylineApi"
import { bindData, byId, notyf } from "../utils"
import * as feather from "feather-icons"

const root = byId("devicesTab")
const devicesTab = root.content.cloneNode(true).firstElementChild

export default function index(app) {
	app.router.on('/devices/new', (match) => {

		const contentE = devicesTab.getElementsByClassName("deviceTabContent")[0]
		while (contentE.firstChild) {
			contentE.removeChild(contentE.firstChild)
		}
		const deviceViewE = byId("newDeviceView").content.cloneNode(true).firstElementChild

		deviceViewE.querySelector('.saveButton').addEventListener('click', () => {
			const newDevice = {
				name: deviceViewE.querySelector('.deviceName').value,
				radioId: deviceViewE.querySelector('.deviceRadio').value,
				type: deviceViewE.querySelector('.deviceType').value,
				frequency: deviceViewE.querySelector('.deviceFrequency').value,
			}
			skylineApi.createDevice(newDevice).then(() => {
				app.router.navigate('/devices')
			}).catch((error) => {
				notyf.error(error.message)
			})
		})

		contentE.appendChild(deviceViewE)
		app.setContent(devicesTab, () => {
			const map = document.getElementById('mapid')
			map.style.marginTop = ''
			map.style.height = ''
		})
		
		const map = document.getElementById('mapid')
		map.style.marginTop = '50vh'
		map.style.height = 'calc(50vh - 40px)'
	})
}